(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-mayoreo-core"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.CCM) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var listeners = [];
    var timer = null;
    var loading = null;

    var CCM = (window.CCM = {
      groups: {},
      variants: {},
      count: 0,
      ready: false,

      parse: function (raw) {
        if (!raw) return null;
        if (typeof raw === 'object') return raw;
        try {
          var cfg = JSON.parse(raw);
          if (!cfg || !cfg.t || !cfg.t.length) return cfg && cfg.s != null ? cfg : null;
          cfg.t.sort(function (a, b) { return a[0] - b[0]; });
          return cfg;
        } catch (e) {
          return null;
        }
      },

      fmt: function (cents) {
        var n = Math.round(cents) / 100;
        var dec = Math.round(cents) % 100 !== 0;
        return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: 2 });
      },

      qty: function (group) {
        return this.groups[group] || 0;
      },

      tierIndex: function (cfg, q) {
        var idx = -1;
        if (!cfg || !cfg.t) return idx;
        for (var i = 0; i < cfg.t.length; i++) if (q >= cfg.t[i][0]) idx = i;
        return idx;
      },

      tierPrice: function (cfg, base, i) {
        var v = cfg.t[i][1];
        var p = cfg.m === 'd' ? base - v : v;
        return Math.max(0, Math.min(base, p));
      },

      unit: function (cfg, base, q) {
        var i = this.tierIndex(cfg, q);
        return i < 0 ? base : this.tierPrice(cfg, base, i);
      },

      next: function (cfg, base, q) {
        if (!cfg || !cfg.t) return null;
        for (var i = 0; i < cfg.t.length; i++) {
          if (cfg.t[i][0] > q) return { index: i, need: cfg.t[i][0] - q, min: cfg.t[i][0], price: this.tierPrice(cfg, base, i) };
        }
        return null;
      },

      on: function (fn) {
        listeners.push(fn);
        if (CCM.ready) fn(CCM);
        else CCM.refresh();
      },

      emit: function () {
        listeners.forEach(function (fn) {
          try { fn(CCM); } catch (e) { console.error('[CCM]', e); }
        });
      },

      refresh: function () {
        if (loading) return loading;
        loading = fetch(root + '?section_id=cc-cart-mayoreo&_=' + Date.now(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var m = html.match(/<script[^>]*data-cc-cart-mayoreo[^>]*>([\s\S]*?)<\/script>/);
            var data = m ? JSON.parse(m[1]) : { lines: [], count: 0 };
            var groups = {};
            var variants = {};
            data.lines.forEach(function (l) {
              groups[l.g] = (groups[l.g] || 0) + l.q;
              variants[l.v] = (variants[l.v] || 0) + l.q;
            });
            CCM.groups = groups;
            CCM.variants = variants;
            CCM.count = data.count || 0;
            CCM.ready = true;
          })
          .catch(function (e) { console.warn('[CCM] cart', e); CCM.ready = true; })
          .then(function () {
            loading = null;
            CCM.emit();
          });
        return loading;
      }
    });

    document.addEventListener('cart:update', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { CCM.refresh(); }, 120);
    });

    // Retour arrière navigateur (bfcache) : le panier a pu changer
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && listeners.length) CCM.refresh();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ccCardInit) return;
    window.__ccCardInit = true;

    document.addEventListener('click', function (event) {
      var sw = event.target.closest && event.target.closest('[data-cc-swatch]');
      if (!sw) return;
      event.preventDefault();
      var card = sw.closest('[data-cc-card]');
      if (!card) return;

      card.querySelectorAll('[data-cc-swatch]').forEach(function (el) {
        el.classList.toggle('is-active', el === sw);
      });

      var img = card.querySelector('.cc-card__img:not(.cc-card__img--hover)');
      if (img && sw.dataset.img) {
        img.removeAttribute('srcset');
        img.setAttribute('sizes', '(min-width: 990px) 23vw, 48vw');
        if (sw.dataset.srcset) img.setAttribute('srcset', sw.dataset.srcset);
        img.src = sw.dataset.img;
        card.classList.add('is-swatched');
      }

      if (sw.dataset.url) {
        card.querySelectorAll('[data-cc-card-link]').forEach(function (a) {
          a.href = sw.dataset.url;
        });
      }
    });
  })();

  (function () {
    if (window.__ccMayoreoCards) return;
    window.__ccMayoreoCards = true;

    function whenCCM(fn) {
      if (window.CCM) fn(window.CCM);
      else setTimeout(function () { whenCCM(fn); }, 40);
    }

    function updateCard(card, CCM) {
      var cfg = card.__ccm || (card.__ccm = CCM.parse(card.dataset.ccM));
      if (!cfg || !cfg.t || !cfg.t.length) return;
      var base = parseInt(card.dataset.ccBase, 10) || 0;
      var q = CCM.qty(cfg.g);
      var idx = CCM.tierIndex(cfg, q);
      var amount = card.querySelector('.cc-card__amount');
      var was = card.querySelector('.cc-card__was');
      var state = card.querySelector('.cc-card__mstate');
      if (amount && !amount.dataset.orig) amount.dataset.orig = amount.textContent;

      card.querySelectorAll('[data-cc-tier]').forEach(function (li) {
        li.classList.toggle('is-active', +li.dataset.ccTier === idx);
      });

      if (idx > -1) {
        amount.textContent = CCM.fmt(CCM.tierPrice(cfg, base, idx));
        if (was) { was.textContent = CCM.fmt(base); was.hidden = false; }
        card.classList.add('is-mayoreo');
      } else {
        if (amount) amount.textContent = amount.dataset.orig;
        if (was) was.hidden = true;
        card.classList.remove('is-mayoreo');
      }

      if (!state) return;
      var nx = CCM.next(cfg, base, q);
      if (q > 0) {
        var txt = idx > -1 ? '✓ Precio mayoreo activo · ' + q + ' en carrito' : q + ' en tu carrito';
        if (nx) txt += ' · +' + nx.need + ' pza' + (nx.need > 1 ? 's' : '') + ' → ' + CCM.fmt(nx.price) + ' c/u';
        state.textContent = txt;
        state.classList.toggle('is-on', idx > -1);
        state.hidden = false;
      } else {
        state.hidden = true;
      }
    }

    function updateAll(CCM) {
      document.querySelectorAll('[data-cc-card][data-cc-m]').forEach(function (card) {
        updateCard(card, CCM);
      });
    }

    whenCCM(function (CCM) {
      if (document.querySelector('[data-cc-card][data-cc-m]') || document.querySelector('[data-cc-quick]')) {
        CCM.on(updateAll);
      }
    });
  })();

  (function () {
    if (window.__ccQuickInit) return;
    window.__ccQuickInit = true;

    var dialog, state, resetTimer;

    function CCMx() {
      return window.CCM || null;
    }

    function el(tag, cls, html) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (html != null) n.innerHTML = html;
      return n;
    }

    function esc(t) {
      return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function cartUrl() {
      return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
    }

    function build() {
      dialog = el('dialog', 'cc-qa');
      dialog.setAttribute('aria-label', 'Agregar al carrito');
      dialog.innerHTML =
        '<form method="dialog" class="cc-qa__panel" novalidate>' +
        '<div class="cc-qa__head"><img class="cc-qa__img" alt="" width="76" height="95">' +
        '<div><p class="cc-qa__title"></p><div class="cc-qa__price"></div><p class="cc-qa__pnote"></p></div>' +
        '<button type="button" class="cc-qa__close" aria-label="Cerrar" data-qa-close>' +
        '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>' +
        '<div class="cc-qa__body"><div class="cc-qa__options"></div>' +
        '<div><p class="cc-qa__label">Cantidad</p><div class="cc-qa__qty">' +
        '<button type="button" data-qa-minus aria-label="Menos">−</button>' +
        '<input type="number" min="1" value="1" inputmode="numeric" aria-label="Cantidad" data-qa-qty>' +
        '<button type="button" data-qa-plus aria-label="Más">+</button></div></div>' +
        '<div class="cc-qa__mayoreo" hidden><p class="cc-qa__label">Precio mayoreo <span>c/u</span></p>' +
        '<ul class="cc-qa__tiers"></ul><p class="cc-qa__hint" aria-live="polite"></p></div>' +
        '<div class="cc-qa__log" hidden><p class="cc-qa__label">Agregado al carrito</p><ul></ul></div>' +
        '</div>' +
        '<div class="cc-qa__foot"><p class="cc-qa__msg" role="status" aria-live="polite"></p>' +
        '<button type="button" class="cc-qa__add" data-qa-add>Agregar al carrito</button>' +
        '<div class="cc-qa__links"><a class="cc-qa__more" href="#">Ver detalles del producto</a>' +
        '<a class="cc-qa__cart" href="' + cartUrl() + '" hidden>Ver carrito →</a></div></div></form>';
      document.body.appendChild(dialog);

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-qa-close]')) {
          e.preventDefault();
          dialog.close();
          return;
        }
        var opt = e.target.closest('[data-qa-opt]');
        if (opt) {
          e.preventDefault();
          state.selected[+opt.dataset.qaOpt] = opt.dataset.value;
          render();
          return;
        }
        var qty = dialog.querySelector('[data-qa-qty]');
        if (e.target.closest('[data-qa-minus]')) {
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
          renderPrice();
          return;
        }
        if (e.target.closest('[data-qa-plus]')) {
          qty.value = (parseInt(qty.value, 10) || 1) + 1;
          renderPrice();
          return;
        }
        var tier = e.target.closest('[data-qa-tier]');
        if (tier) {
          e.preventDefault();
          var C = CCMx();
          var inCart = C && state.cfg ? C.qty(state.cfg.g) : 0;
          qty.value = Math.max(1, +tier.dataset.qaTier - inCart);
          renderPrice();
          return;
        }
        if (e.target.closest('[data-qa-add]')) {
          e.preventDefault();
          add();
        }
      });

      dialog.querySelector('[data-qa-qty]').addEventListener('input', renderPrice);

      dialog.addEventListener('close', function () {
        if (state && state.trigger) state.trigger.focus();
      });

      if (window.CCM) window.CCM.on(function () { if (dialog.open) renderPrice(); });
      else {
        var wait = setInterval(function () {
          if (!window.CCM) return;
          clearInterval(wait);
          window.CCM.on(function () { if (dialog.open) renderPrice(); });
        }, 50);
      }
    }

    function currentVariant() {
      var p = state.product;
      return p.variants.find(function (v) {
        return v.options.every(function (o, i) {
          return o === state.selected[i];
        });
      });
    }

    function isValueAvailable(index, value) {
      return state.product.variants.some(function (v) {
        if (!v.available || v.options[index] !== value) return false;
        return v.options.every(function (o, i) {
          return i === index || i > index || o === state.selected[i];
        });
      });
    }

    function renderPrice() {
      if (!state) return;
      var v = currentVariant();
      var priceEl = dialog.querySelector('.cc-qa__price');
      var note = dialog.querySelector('.cc-qa__pnote');
      var box = dialog.querySelector('.cc-qa__mayoreo');
      var C = CCMx();
      var cfg = state.cfg;
      var qty = Math.max(1, parseInt(dialog.querySelector('[data-qa-qty]').value, 10) || 1);
      note.textContent = '';

      if (!v) {
        priceEl.textContent = '';
        box.hidden = true;
        return;
      }

      if (!cfg || !cfg.t || !cfg.t.length || !C) {
        priceEl.innerHTML = esc(v.price) + (v.compare ? ' <s>' + esc(v.compare) + '</s>' : '');
        box.hidden = true;
        return;
      }

      var base = v.p;
      var inCart = C.qty(cfg.g);
      var total = inCart + qty;
      var idx = C.tierIndex(cfg, total);
      var unit = C.unit(cfg, base, total);

      priceEl.innerHTML =
        '<span class="cc-qa__now">' + C.fmt(unit) + '</span>' +
        (unit < base ? ' <s>' + C.fmt(base) + '</s>' : v.compare ? ' <s>' + esc(v.compare) + '</s>' : '') +
        ' <small>c/u</small>';
      note.textContent = qty > 1 ? 'Total: ' + C.fmt(unit * qty) + ' por ' + qty + ' pzas' : '';

      var list = dialog.querySelector('.cc-qa__tiers');
      list.innerHTML = cfg.t
        .map(function (t, i) {
          return (
            '<li><button type="button" data-qa-tier="' + t[0] + '" class="' + (i === idx ? 'is-active' : '') + '">' +
            '<span>' + t[0] + '+ pzas</span><strong>' + C.fmt(C.tierPrice(cfg, base, i)) + '</strong></button></li>'
          );
        })
        .join('');

      var nx = C.next(cfg, base, total);
      var parts = [];
      if (inCart > 0) parts.push('Ya tienes ' + inCart + ' en tu carrito');
      if (idx > -1) parts.push('✓ Precio mayoreo aplicado');
      if (nx) parts.push('Agrega ' + nx.need + ' pza' + (nx.need > 1 ? 's' : '') + ' más para pagar ' + C.fmt(nx.price) + ' c/u');
      if (cfg.c) parts.push(cfg.c);
      var hint = dialog.querySelector('.cc-qa__hint');
      hint.textContent = parts.join(' · ');
      hint.classList.toggle('is-on', idx > -1);
      box.hidden = false;
    }

    function render() {
      var p = state.product;
      var v = currentVariant();
      var optionsWrap = dialog.querySelector('.cc-qa__options');
      optionsWrap.innerHTML = '';

      if (!p.single) {
        p.options.forEach(function (o, i) {
          var box = el('div', 'cc-qa__option');
          box.appendChild(el('p', 'cc-qa__label', esc(o.name) + ': <span>' + esc(state.selected[i]) + '</span>'));
          var list = el('div', 'cc-qa__values');
          o.values.forEach(function (val) {
            var b = el('button');
            b.type = 'button';
            b.dataset.qaOpt = i;
            b.dataset.value = val.name;
            b.title = val.name;
            b.setAttribute('aria-pressed', String(state.selected[i] === val.name));
            if (o.color && (val.c || val.i)) {
              b.className = 'cc-qa__sw';
              if (val.c) b.style.setProperty('--sw', val.c);
              if (val.i) b.innerHTML = '<img src="' + esc(val.i) + '" alt="" loading="lazy">';
              b.setAttribute('aria-label', val.name);
            } else {
              b.className = 'cc-qa__pill';
              b.textContent = val.name;
            }
            if (state.selected[i] === val.name) b.classList.add('is-selected');
            if (!isValueAvailable(i, val.name)) b.classList.add('is-out');
            list.appendChild(b);
          });
          box.appendChild(list);
          optionsWrap.appendChild(box);
        });
      }

      var addBtn = dialog.querySelector('[data-qa-add]');
      var img = dialog.querySelector('.cc-qa__img');
      if (v && v.image) img.src = v.image;
      var ok = v && v.available;
      clearTimeout(resetTimer);
      addBtn.disabled = !ok;
      addBtn.classList.remove('is-done');
      addBtn.textContent = !v ? 'No disponible' : ok ? 'Agregar al carrito' : 'Agotado';
      dialog.querySelector('.cc-qa__msg').textContent = '';
      renderPrice();
    }

    function open(card, trigger) {
      var script = card.querySelector('[data-cc-product-json]');
      if (!script) return;
      var product;
      try {
        product = JSON.parse(script.textContent);
      } catch (e) {
        window.location.href = card.querySelector('a').href;
        return;
      }
      if (!dialog) build();

      var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      var activeSwatch = card.querySelector('[data-cc-swatch].is-active');
      var cfg = null;
      if (product.m) {
        cfg = product.m;
        if (cfg.t) cfg.t.sort(function (a, b) { return a[0] - b[0]; });
      }
      state = { product: product, cfg: cfg, selected: first.options.slice(), trigger: trigger };

      if (activeSwatch) {
        var ci = product.options.findIndex(function (o) { return o.color; });
        if (ci > -1) {
          var name = activeSwatch.getAttribute('title');
          var match = product.variants.find(function (v) { return v.available && v.options[ci] === name; });
          if (match) state.selected = match.options.slice();
        }
      }

      dialog.querySelector('.cc-qa__title').textContent = product.title;
      dialog.querySelector('.cc-qa__img').src = product.image || '';
      dialog.querySelector('.cc-qa__more').href = product.url;
      dialog.querySelector('[data-qa-qty]').value = 1;
      var log = dialog.querySelector('.cc-qa__log');
      log.hidden = true;
      log.querySelector('ul').innerHTML = '';
      dialog.querySelector('.cc-qa__cart').hidden = true;
      render();
      dialog.showModal();
      if (window.CCM) window.CCM.refresh();
    }

    function notifyCart(v, qty, res) {
      // Met à jour compteur et tiroir panier sans l'ouvrir : la fenêtre d'ajout rapide reste au premier plan
      var drawers = Array.prototype.slice.call(document.querySelectorAll('cart-drawer-component[auto-open]'));
      drawers.forEach(function (d) { d.removeAttribute('auto-open'); });
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: String(v.id),
            data: { source: 'cc-quick-add', itemCount: qty, variantId: String(v.id), sections: res.sections }
          }
        })
      );
      setTimeout(function () {
        drawers.forEach(function (d) { d.setAttribute('auto-open', ''); });
      }, 0);
    }

    function add() {
      var v = currentVariant();
      if (!v || !v.available) return;
      var btn = dialog.querySelector('[data-qa-add]');
      var msg = dialog.querySelector('.cc-qa__msg');
      var qtyInput = dialog.querySelector('[data-qa-qty]');
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      clearTimeout(resetTimer);
      btn.disabled = true;
      btn.classList.remove('is-done');
      btn.textContent = 'Agregando…';
      msg.textContent = '';

      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', qty);
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) {
        if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
      });
      if (ids.length) fd.append('sections', ids.join(','));

      var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js';
      fetch(url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            btn.disabled = false;
            btn.textContent = 'Agregar al carrito';
            msg.textContent = res.description || res.message || 'No se pudo agregar.';
            return;
          }
          btn.disabled = false;
          btn.classList.add('is-done');
          btn.textContent = '✓ Agregado · agregar más';

          var label = state.product.single ? state.product.title : v.options.join(' / ');
          var log = dialog.querySelector('.cc-qa__log');
          var li = el('li', null, '<strong>' + qty + ' ×</strong> ' + esc(label));
          log.querySelector('ul').appendChild(li);
          log.hidden = false;
          dialog.querySelector('.cc-qa__cart').hidden = false;
          qtyInput.value = 1;

          notifyCart(v, qty, res);
          if (window.CCM) window.CCM.refresh();

          resetTimer = setTimeout(function () {
            if (!dialog.open) return;
            btn.classList.remove('is-done');
            btn.textContent = 'Agregar al carrito';
          }, 2200);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Agregar al carrito';
          msg.textContent = 'Error de conexión, inténtalo de nuevo.';
        });
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-cc-quick]');
      if (!t) return;
      e.preventDefault();
      open(t.closest('[data-cc-card]'), t);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ccp-script"] && !Shopify.designMode) return;
  try {
    (function () {
    function whenCCM(fn, n) {
      if (window.CCM) return fn(window.CCM);
      if ((n || 0) > 100) return fn(null);
      setTimeout(function () { whenCCM(fn, (n || 0) + 1); }, 50);
    }

    function fmt(c) {
      if (window.CCM) return window.CCM.fmt(c);
      return '$' + (Math.round(c) / 100).toLocaleString('es-MX');
    }

    function init(root) {
      if (root.__ccp) return;
      root.__ccp = true;

      var data = JSON.parse(root.querySelector('[data-ccp-json]').textContent);
      var cfg = null;
      try { cfg = JSON.parse(root.dataset.cfg || 'null'); } catch (e) { cfg = null; }
      if (cfg && cfg.t) cfg.t.sort(function (a, b) { return a[0] - b[0]; });
      if (cfg && (!cfg.t || !cfg.t.length)) cfg = cfg.s ? cfg : null;
      var resale = parseInt(root.dataset.resale, 10) || 0;
      var resaleEst = root.dataset.resaleEst === 'true';

      var $ = function (s) { return root.querySelector(s); };
      var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

      var slides = $('[data-ccp-slides]');
      var thumbs = $$('[data-ccp-thumb]');
      var dots = $$('.ccp__dots span');
      var qtyIn = $('[data-ccp-qty]');
      var addBtns = $$('[data-ccp-add]');
      var mainAdd = addBtns[0];
      var opts = $$('[data-ccp-opt]');

      var params = new URLSearchParams(location.search);
      var startId = parseInt(params.get('variant'), 10);
      var variant = data.variants.find(function (v) { return v.id === startId; }) ||
        data.variants.find(function (v) { return v.a; }) || data.variants[0];
      var selected = variant.o.slice();
      var inCart = 0;

      /* ---------- Galerie ---------- */
      function slideTo(i) {
        if (!slides) return;
        var li = slides.children[i];
        if (li) slides.scrollTo({ left: li.offsetLeft, behavior: 'smooth' });
      }

      function currentSlide() {
        return slides ? Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)) : 0;
      }

      if (slides) {
        slides.addEventListener('scroll', function () {
          window.requestAnimationFrame(function () {
            var i = currentSlide();
            thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
            dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
          });
        }, { passive: true });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { slideTo(parseInt(t.dataset.ccpThumb, 10)); });
      });
      var prev = $('[data-ccp-prev]');
      var next = $('[data-ccp-next]');
      if (prev) prev.addEventListener('click', function () { slideTo(Math.max(0, currentSlide() - 1)); });
      if (next) next.addEventListener('click', function () { slideTo(Math.min(slides.children.length - 1, currentSlide() + 1)); });

      function showVariantMedia(v) {
        if (!v.m || !slides) return;
        var li = slides.querySelector('[data-media-id="' + v.m + '"]');
        if (li) slides.scrollTo({ left: li.offsetLeft, behavior: 'smooth' });
      }

      /* ---------- Variantes ---------- */
      function findVariant() {
        return data.variants.find(function (v) {
          return v.o.every(function (o, i) { return o === selected[i]; });
        });
      }

      function refreshSwatches() {
        opts.forEach(function (fs) {
          var idx = parseInt(fs.dataset.ccpOpt, 10);
          fs.querySelector('[data-ccp-optval]').textContent = selected[idx];
          fs.querySelectorAll('[data-ccp-val]').forEach(function (b) {
            var val = b.dataset.ccpVal;
            var on = val === selected[idx];
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            var probe = selected.slice();
            probe[idx] = val;
            var pv = data.variants.find(function (v) { return v.o.every(function (o, i) { return o === probe[i]; }); });
            b.classList.toggle('is-na', !pv || !pv.a);
          });
        });
      }

      opts.forEach(function (fs) {
        var idx = parseInt(fs.dataset.ccpOpt, 10);
        fs.addEventListener('click', function (e) {
          var b = e.target.closest('[data-ccp-val]');
          if (!b) return;
          selected[idx] = b.dataset.ccpVal;
          var v = findVariant();
          if (v) {
            variant = v;
            showVariantMedia(v);
            var u = new URL(location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(null, '', u.toString());
          }
          refreshSwatches();
          render();
        });
      });

      /* ---------- Prix mayoreo ---------- */
      function unitFor(base, q) {
        if (!cfg) return base;
        if (!cfg.t || !cfg.t.length) return cfg.s ? Math.min(base, cfg.s) : base;
        var idx = -1;
        for (var i = 0; i < cfg.t.length; i++) if (q >= cfg.t[i][0]) idx = i;
        if (idx < 0) return base;
        var v = cfg.t[idx][1];
        return Math.max(0, Math.min(base, cfg.m === 'd' ? base - v : v));
      }

      var tiersEl = $('[data-ccp-tiers]');
      function buildTiers() {
        if (!tiersEl || !cfg || !cfg.t) return;
        var base = variant.p;
        var first = cfg.t[0][0];
        var html = '<button type="button" class="ccp__tier" data-min="1"><span class="ccp__tier-q">' +
          (first > 2 ? '1–' + (first - 1) : '1') + ' pza' + (first > 2 ? 's' : '') + '</span><span class="ccp__tier-p">' + fmt(base) + '</span></button>';
        cfg.t.forEach(function (t) {
          html += '<button type="button" class="ccp__tier" data-min="' + t[0] + '"><span class="ccp__tier-q">' + t[0] + '+ pzas</span><span class="ccp__tier-p">' + fmt(unitFor(base, t[0])) + '</span></button>';
        });
        tiersEl.innerHTML = html;
      }
      if (tiersEl) {
        tiersEl.addEventListener('click', function (e) {
          var b = e.target.closest('.ccp__tier');
          if (!b) return;
          var need = Math.max(1, parseInt(b.dataset.min, 10) - inCart);
          qtyIn.value = need;
          render();
        });
      }

      function qty() {
        var q = parseInt(qtyIn.value, 10);
        return isNaN(q) || q < 1 ? 1 : q;
      }

      var lastBase = null;
      function render() {
        var q = qty();
        var base = variant.p;
        if (base !== lastBase) { buildTiers(); lastBase = base; }
        var total = inCart + q;
        var unit = unitFor(base, total);
        var compare = variant.c > base ? variant.c : 0;
        var ref = unit < base ? base : compare;

        $('[data-ccp-unit]').textContent = fmt(unit);
        $('[data-ccp-was]').textContent = ref > unit ? fmt(ref) : '';
        var off = $('[data-ccp-off]');
        if (ref > unit) {
          off.hidden = false;
          off.textContent = '-' + Math.round((1 - unit / ref) * 100) + '%';
        } else off.hidden = true;
        root.querySelector('.ccp__price').classList.toggle('is-mayo', unit < base);

        $('[data-ccp-total]').textContent = fmt(unit * q);
        var sunit = $('[data-ccp-sunit]');
        if (sunit) sunit.textContent = fmt(unit);
        var sq = $('[data-ccp-sqty]');
        if (sq) sq.textContent = q + (q > 1 ? ' pzas' : ' pza');

        addBtns.forEach(function (b) { b.disabled = !variant.a; });
        $('[data-ccp-addtxt]').textContent = variant.a ? 'Agregar al carrito' : 'Agotado';

        // Paliers
        if (tiersEl && cfg && cfg.t) {
          var tiers = tiersEl.querySelectorAll('.ccp__tier');
          var idx = -1;
          for (var i = 0; i < cfg.t.length; i++) if (total >= cfg.t[i][0]) idx = i;
          tiers.forEach(function (t, k) { t.classList.toggle('is-on', k === idx + 1); });
          var nx = null;
          for (var j = 0; j < cfg.t.length; j++) if (cfg.t[j][0] > total) { nx = cfg.t[j]; break; }
          var prevMin = idx >= 0 ? cfg.t[idx][0] : 0;
          var bar = $('[data-ccp-bar]');
          var nextEl = $('[data-ccp-hint]');
          if (nx) {
            bar.style.width = Math.min(100, ((total - prevMin) / (nx[0] - prevMin)) * 100) + '%';
            var nu = unitFor(base, nx[0]);
            nextEl.innerHTML = 'Agrega <strong>' + (nx[0] - total) + ' pza' + (nx[0] - total > 1 ? 's' : '') + '</strong> más y paga <strong>' + fmt(nu) + ' c/u</strong> (ahorras ' + fmt(base - nu) + ' por pieza).';
          } else {
            bar.style.width = '100%';
            nextEl.innerHTML = '<strong>¡Tienes el mejor precio!</strong> Ahorras ' + fmt((base - unit) * q) + ' en este pedido.';
          }
        }

        // Déjà au panier
        var ic = $('[data-ccp-incart]');
        if (inCart > 0) {
          ic.hidden = false;
          ic.innerHTML = 'Ya tienes ' + inCart + ' pza' + (inCart > 1 ? 's' : '') + ' de este modelo en tu carrito: se suman al mayoreo. <a href="' + cartUrl() + '" data-ccp-open>Ver carrito</a>';
        } else ic.hidden = true;

        // Gain
        var pv = $('[data-ccp-profit]');
        if (pv && resale > 0) {
          var gain = Math.max(0, resale - unit) * q;
          pv.textContent = '+' + fmt(gain);
          $('[data-ccp-psub]').textContent = q + ' pza' + (q > 1 ? 's' : '') + ' × ' + fmt(Math.max(0, resale - unit)) +
            ' · reventa ' + (resaleEst ? 'estimada' : 'sugerida') + ' ' + fmt(resale);
        }
      }

      function cartUrl() {
        return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
      }

      $$('[data-ccp-minus]').forEach(function (b) { b.addEventListener('click', function () { qtyIn.value = Math.max(1, qty() - 1); render(); }); });
      $$('[data-ccp-plus]').forEach(function (b) { b.addEventListener('click', function () { qtyIn.value = qty() + 1; render(); }); });
      qtyIn.addEventListener('input', render);
      qtyIn.addEventListener('blur', function () { qtyIn.value = qty(); render(); });

      /* ---------- Panier ---------- */
      function openCart(e) {
        var d = document.querySelector('cart-drawer-component');
        if (d && typeof d.open === 'function') {
          e.preventDefault();
          d.open();
        } else if (d && typeof d.showDialog === 'function') {
          e.preventDefault();
          d.showDialog();
        }
      }
      root.addEventListener('click', function (e) {
        var a = e.target.closest('[data-ccp-open]');
        if (a) openCart(e);
      });

      function notifyCart(v, q, res) {
        var drawers = Array.prototype.slice.call(document.querySelectorAll('cart-drawer-component[auto-open]'));
        drawers.forEach(function (d) { d.removeAttribute('auto-open'); });
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: {}, sourceId: String(v.id), data: { source: 'cc-product', itemCount: q, variantId: String(v.id), sections: res.sections } }
        }));
        setTimeout(function () { drawers.forEach(function (d) { d.setAttribute('auto-open', ''); }); }, 0);
      }

      var resetT;
      function add() {
        if (!variant.a) return;
        var q = qty();
        var msg = $('[data-ccp-msg]');
        var txt = $('[data-ccp-addtxt]');
        clearTimeout(resetT);
        addBtns.forEach(function (b) { b.disabled = true; b.classList.remove('is-done'); });
        txt.textContent = 'Agregando…';
        msg.textContent = '';
        msg.classList.remove('is-err');

        var fd = new FormData();
        fd.append('id', variant.id);
        fd.append('quantity', q);
        var ids = [];
        document.querySelectorAll('cart-items-component').forEach(function (c) {
          if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
        });
        if (ids.length) fd.append('sections', ids.join(','));

        fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            addBtns.forEach(function (b) { b.disabled = false; });
            if (res.status) {
              txt.textContent = 'Agregar al carrito';
              msg.classList.add('is-err');
              msg.textContent = res.description || res.message || 'No se pudo agregar.';
              return;
            }
            addBtns.forEach(function (b) { b.classList.add('is-done'); });
            txt.textContent = '✓ Agregado';
            var sm = root.querySelector('.ccp__add--sm');
            if (sm) sm.textContent = '✓ Agregado';
            var label = data.variants.length > 1 ? selected.join(' / ') : data.title;
            var more = root.dataset.more ? ' ' + root.dataset.more : '';
            msg.innerHTML = q + ' × ' + label + ' agregado. <a href="' + cartUrl() + '" data-ccp-open>Ver carrito</a>' + more + '.';
            qtyIn.value = 1;
            notifyCart(variant, q, res);
            if (window.CCM) window.CCM.refresh();
            resetT = setTimeout(function () {
              addBtns.forEach(function (b) { b.classList.remove('is-done'); });
              txt.textContent = 'Agregar al carrito';
              if (sm) sm.textContent = 'Agregar';
            }, 2200);
          })
          .catch(function () {
            addBtns.forEach(function (b) { b.disabled = false; });
            txt.textContent = 'Agregar al carrito';
            msg.classList.add('is-err');
            msg.textContent = 'Error de conexión, inténtalo de nuevo.';
          });
      }
      addBtns.forEach(function (b) { b.addEventListener('click', add); });

      /* ---------- Barre fixe ---------- */
      var sticky = $('[data-ccp-sticky]');
      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }).observe(mainAdd);
      }

      /* ---------- Panier existant (CCM) ---------- */
      refreshSwatches();
      render();
      whenCCM(function (C) {
        if (!C || !cfg) return;
        C.on(function () {
          inCart = C.qty(cfg.g);
          render();
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-ccp]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer-ikea"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ccDrawerInit) return;
    window.__ccDrawerInit = true;

    function getDrawer(el) {
      return (el && el.closest('[data-cc-drawer]')) || document.querySelector('[data-cc-drawer]');
    }

    function resetPanels(drawer) {
      drawer.querySelectorAll('.cc-panel--sub').forEach(function (panel) {
        panel.classList.remove('is-active', 'is-behind');
        panel.setAttribute('aria-hidden', 'true');
        panel.inert = true;
      });
      var root = drawer.querySelector('.cc-panel--root');
      if (root) {
        root.classList.remove('is-behind');
        root.inert = false;
      }
      drawer.querySelectorAll('[data-cc-go]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function open(drawer) {
      if (!drawer || drawer.open) return;
      resetPanels(drawer);
      drawer.showModal();
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
      });
    }

    function close(drawer) {
      if (!drawer || !drawer.open) return;
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      var done = function () {
        if (drawer.open) drawer.close();
      };
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return done();
      drawer.addEventListener('transitionend', done, { once: true });
      setTimeout(done, 450);
    }

    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t.closest) return;

      var opener = t.closest('[data-cc-drawer-open]');
      if (opener) {
        event.preventDefault();
        var wrap = opener.parentElement;
        open((wrap && wrap.querySelector('[data-cc-drawer]')) || getDrawer());
        return;
      }

      var closer = t.closest('[data-cc-drawer-close]');
      if (closer) {
        event.preventDefault();
        close(getDrawer(closer));
        return;
      }

      var go = t.closest('[data-cc-go]');
      if (go) {
        event.preventDefault();
        var drawer = getDrawer(go);
        var panel = drawer.querySelector('[data-cc-panel="' + go.getAttribute('data-cc-go') + '"]');
        var from = go.closest('.cc-panel');
        if (!panel) return;
        panel.inert = false;
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add('is-active');
        go.setAttribute('aria-expanded', 'true');
        if (from) {
          from.classList.add('is-behind');
          from.inert = true;
        }
        var scroll = panel.querySelector('.cc-panel__scroll');
        if (scroll) scroll.scrollTop = 0;
        var back = panel.querySelector('[data-cc-back]');
        if (back) setTimeout(function () { back.focus(); }, 50);
        return;
      }

      var backBtn = t.closest('[data-cc-back]');
      if (backBtn) {
        event.preventDefault();
        var d = getDrawer(backBtn);
        var sub = backBtn.closest('.cc-panel--sub');
        if (sub) {
          var parent = d.querySelector('[data-cc-panel="' + (sub.getAttribute('data-cc-parent') || 'root') + '"]');
          sub.classList.remove('is-active');
          sub.setAttribute('aria-hidden', 'true');
          sub.inert = true;
          var trigger = d.querySelector('[data-cc-go="' + sub.getAttribute('data-cc-panel') + '"]');
          if (parent) {
            parent.classList.remove('is-behind');
            parent.inert = false;
          }
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          }
        }
        return;
      }

      // Clic sur le fond (hors panneau) : fermer
      if (t.matches && t.matches('[data-cc-drawer]')) close(t);
    });

    document.addEventListener(
      'cancel',
      function (event) {
        if (event.target && event.target.matches && event.target.matches('[data-cc-drawer]')) {
          event.preventDefault();
          close(event.target);
        }
      },
      true
    );

    window.addEventListener('pageshow', function () {
      document.documentElement.style.overflow = '';
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-arches-base"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ccMegaInit) return;
    window.__ccMegaInit = true;

    function update(track) {
      if (!track) return;
      var mega = track.closest('[data-cc-mega]');
      if (!mega) return;
      var bar = mega.querySelector('[data-cc-bar]');
      var prev = mega.querySelector('[data-cc-prev]');
      var next = mega.querySelector('[data-cc-next]');
      var max = track.scrollWidth - track.clientWidth;
      if (bar && track.scrollWidth > 0) {
        var ratio = Math.min(1, track.clientWidth / track.scrollWidth);
        bar.style.width = ratio * 100 + '%';
        var progress = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + progress * ((1 - ratio) / ratio) * 100 + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    function updateAll() {
      document.querySelectorAll('[data-cc-track]').forEach(update);
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cc-prev], [data-cc-next]');
      if (!btn) return;
      var mega = btn.closest('[data-cc-mega]');
      var track = mega && mega.querySelector('[data-cc-track]');
      if (!track) return;
      event.preventDefault();
      var item = track.querySelector('.cc-arch');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: btn.hasAttribute('data-cc-next') ? step : -step, behavior: 'smooth' });
    });

    document.addEventListener(
      'scroll',
      function (event) {
        var target = event.target;
        if (target && target.matches && target.matches('[data-cc-track]')) update(target);
      },
      true
    );

    document.addEventListener('pointerover', function (event) {
      var item = event.target.closest && event.target.closest('.menu-list__list-item');
      if (item) item.querySelectorAll('[data-cc-track]').forEach(update);
    });

    window.addEventListener('resize', updateAll);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll);
    } else {
      updateAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
